import React from 'react'
import ManageBooks from '../manage-books/ManageBooks'
import { ELibraryCategory } from '../../enum/elibrary_enum'
import { routeName } from '../../../../routes/routeName'
import { useTranslation } from 'react-i18next'

type Props = {}

const ManagePodcast: React.FC<Props> = ({ }: Props) => {
    const { t } = useTranslation()
    return (
        <ManageBooks
            button_add_name={t("เพิ่มพอดแคสต์")}
            category={ELibraryCategory.PODCAST}
            menu_name={t('จัดการพอดแคสต์')}
            path_create={routeName.e_library.manage_podcast_create}
        />
    )
}

export default ManagePodcast